import { AuthService } from "../../../services";
import { createActions } from "redux-actions";
import { Dispatch } from "redux";
import { loadCallback, PermissionUtil } from "../../../utils";
import { RootState, TCb } from "../../../models";

export const UserAcionTypes = createActions({
  LOAD_ME_START: (data) => data,
  LOAD_ME_SUCCESS: (data) => data,
  CLEAR_ME: (data) => data,
});

const loadMe = (cb?: TCb) => async (dispath: Dispatch, getState: () => RootState) => {
  dispath(
    UserAcionTypes.loadMeStart({
      ...getState().me,
      loading: true,
    })
  );

  AuthService.loadMe()
    .then((res) => {
      if (res && (res.status === 200 || res.status === 201)) {
        dispath(
          UserAcionTypes.loadMeSuccess({
            data: {
              ...res.data.data,
              modules: PermissionUtil.getModulePermisstionByEmail(res.data.data?.email || ""),
            },
            loading: false,
          })
        );
        loadCallback(cb?.success);
      } else {
        loadCallback(cb?.error, res);
      }
    })
    .catch((err) => {
      loadCallback(cb?.error, err);
    });
};

const clearMe = () => async (dispath: Dispatch, getState: () => RootState) => {
  dispath(
    UserAcionTypes.CLEAR_ME({
      data: null,
      loading: false,
    })
  );
};

export const UserActions = {
  loadMe,
  clearMe,
};
